import { useEffect, useState } from "react";
import CreateSchoolProfileContainer from "src/containers/admin/create-school-profile-container";
import SchoolInfoContainer from "src/containers/admin/school-info-container";
import AnotherInfoContainer from "src/containers/admin/school-another-info-container";
import AboutSchool from "src/containers/admin/about-school-container";
import SchoolGallery from "src/containers/admin/school-gallery-container";
import SchoolAtachments from "src/containers/admin/school-attachments-container";
import SocialMediaAccs from "src/containers/admin/social-media-accs-container";
import LayoutComponent from "src/components/user/layout-component";
import WhatsAppIcon from "src/components/common/whats-app-icon";
import { useTranslation } from "react-i18next";

function CreateSchoolProfilePage() {
  const { i18n } = useTranslation();
  const [navOnScrollStyle, setNavOnScrollStyle] = useState<boolean>(false);
  const [endOfPage, setEndOfPage] = useState<boolean>(false);
  const changeNavStyle = () => {
    window.scrollY >= 50
      ? setNavOnScrollStyle(true)
      : setNavOnScrollStyle(false);
  };

  const reachesEndOfPage = () => {
    window.innerHeight + window.scrollY >= document.body.offsetHeight
      ? setEndOfPage(true)
      : setEndOfPage(false);
  };
  useEffect(() => {
    window.addEventListener("scroll", changeNavStyle);
    window.addEventListener("scroll", reachesEndOfPage);

    return () => {
      window.removeEventListener("scroll", changeNavStyle);
      window.removeEventListener("scroll", reachesEndOfPage);
    };
  }, []);
  return (
    <LayoutComponent showLogo={true}>
      <>
        <div
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
          className="flex flex-row gap-32 tablet:gap-0 tablet:justify-between mobile:justify-center h-full bg-zinc-50"
        >
          <div
            className={`${
              endOfPage ? "mobile:mb-[73px]" : ""
            } flex flex-row mt-56 bg-zinc-50 mobile:mt-0 mobile:fixed mobile:z-50 mobile:bottom-0 mobile:p-2.5 mobile:bg-white mobile:w-full mobile:justify-center`}
          >
            <CreateSchoolProfileContainer />
          </div>
          <div className="flex flex-col gap-16 mt-56 mb-20 tablet:pl-8 justify-start mobile:mt-24 mobile:gap-5 mobile:mb-14">
            <SchoolInfoContainer />
            <AnotherInfoContainer />
            <AboutSchool />
            <SchoolGallery />
            <SchoolAtachments />
            <SocialMediaAccs />
          </div>
        </div>
        <div className={`${endOfPage ? "mobile:mb-10" : ""}`}>
          <WhatsAppIcon bottomNumber={endOfPage ? "20" : ""} />
        </div>
      </>
    </LayoutComponent>
  );
}

export default CreateSchoolProfilePage;
